<template>
  <div  v-if="!totalmente_carregada" >
    <div class="wrapper">
      <!-- modal de verificar carregamento total da pagina-->
      <div  
        style="display: block; padding-top: 0px"
        class="w3-modal w3-hide-large" 
        v-cloak>
        
        <div 
          class="w3-modal-content w3-theme" 
          style="font-size:4vw; height:100vh; border-radius:0px;" 
          @click.stop>
          
          <center class="w3-theme">
            <img
              src="static/imagens/logos/logo_48.png" 
              style="width: 8rem; margin-top: 10vh;"
              class="w3-margin-bottom">
          </center>
          
          <div class="w3-container w3-center" style="padding:0px;">
            <div class="w3-col" style="padding:0px;">
            <center>
              <div class="w3-col">
                <strong>&nbsp;Carregando aguarde...</strong><br>
              </div>
            </center>
            
              <div class="sk-carregando w3-col " style="padding:0px">
                <div class="sk-carregando-dot"></div>
              </div>
              
              <center v-if="mostrar_dados_adicionais">
                <div class="w3-col " style="font-size:2.5vw;">
                  <label>Velocidade de conexão: {{velocidade_transferencia_dados}} Mb/s</label><br>
                  <label>Tipo de rede: {{tipo_rede}}</label><br>
                  <label v-if="tipo_conexao">Tipo de conexão: {{tipo_conexao}}</label><br>
                  <label>Latência:  {{latencia}}ms</label><br>
                  <label>
                    <span>Modo Lite(economia de dados): </span>
                    <span v-if="modo_lite">Ativado</span>
                    <span v-if="!modo_lite">Desativado</span>
                  </label>
                  <br>
                  <label>Memoria capacidade: {{memoria_do_dispositivo}}</label><br> 
                </div>
              </center>
            </div>
          </div>
        </div>
      </div>
      
      <div 
        style="display: block; padding-top: 20px;" 
        class="w3-modal w3-hide-small w3-hide-medium"
        v-cloak>
        <div
          class="w3-modal-content w3-theme" 
          style="font-size:2vw; height:30vh; border-radius:25px;" 
          @click.stop>
          <center class="w3-theme">
            <img alt="" src="static/imagens/logos/logo_48.png" 
            style="width: 8rem;" 
            class="w3-margin-bottom">
          </center>
          
          <div class="w3-container w3-center" style="padding:0px;">
            <div class="w3-col" style="padding:0px;">
            <center>
              <div class="w3-col">
                <strong>&nbsp;Carregando aguarde...</strong><br>
              </div>
            </center>
            
              <div class="sk-carregando w3-col " style="padding:0px">
                <div class="sk-carregando-dot"></div>
                <div class="sk-carregando-dot"></div>
                <div class="sk-carregando-dot"></div>
                <div class="sk-carregando-dot"></div>
                <div class="sk-carregando-dot"></div>
                <div class="sk-carregando-dot"></div>
              </div>              
            
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  export default {
    name: 'CarregandoAguarde',
    data () {
      return {
        mostrar_dados_adicionais: false,
        totalmente_carregada: true,
      
        /*dados do dispositivo*/
        dados_dispositivo: '',
        geolocalizacao: '',
        tipo_rede: '',
        economia_de_dados: '',
        tipo_conexao: '',
        velocidade_transferencia_dados: '',
        latencia: '',
        modo_lite: false,
        memoria_do_dispositivo: '',
        plataforma: '',
      }
    },
    mounted(){
      setInterval(() => {
        this.coletarDadosDispositivo()
      }, 2000)
      setTimeout(() => {
        this.carregarDadosAdicionais()
      }, 4000)
      setInterval(() => {
        this.carregouPaginaToda()
      },1000)
      
    },
  
    methods: {
      carregouPaginaToda(){
        let string = document.readyState;
        if(string == 'loading'){
          this.totalmente_carregada = false;
        }
        else if(string !== 'loading'){
          this.totalmente_carregada =  true;
        }
      },
      
      carregarDadosAdicionais(){
        this.mostrar_dados_adicionais = true
      },
      
      coletarDadosDispositivo(){
        this.memoria_do_dispositivo = Biblioteca.buscarMemoriaRamDispositivo();
        this.geolocalizacao = Biblioteca.buscarGeolocalizacaoDispositivo();
        this.plataforma = Biblioteca.buscarPlataformaDispositivo();
        this.dados_dispositivo = Biblioteca.buscarAplicativoVersaoDispositivo();
        this.tipo_conexao = Biblioteca.buscarTipoConexaoDispositivo();
        this.velocidade_transferencia_dados = Biblioteca.buscarVelocidadeDownloadDispositivo();
        this.latencia = Biblioteca.buscarDadosLatenciaDispositivo();
        this.tipo_rede = Biblioteca.buscarTipoRedeDispositivo();
        this.modo_lite = Biblioteca.buscarModoEconomiaDadosDispositivo();
      },
  }
}
</script>

<style scoped>
  .sk-carregando {
    width: 100%;
    height: 10px;
    position: relative;
    animation: sk-carregando 2.5s infinite linear both;
  }
  
  .sk-carregando-dot {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0; 
    animation: sk-carregando-dot 2.0s infinite ease-in-out both; 
  }

  .sk-carregando-dot:before {
    content: '';
    display: block;
    width: 100%;
    height: 25%;
    background-color: white;
    border-radius: 0%;
    animation: sk-carregando-dot-before 2.0s infinite ease-in-out both; 
  }

  .sk-carregando-dot:nth-child(1) { animation-delay: -1.1s; }
  .sk-carregando-dot:nth-child(2) { animation-delay: -1.0s; }
  .sk-carregando-dot:nth-child(3) { animation-delay: -0.9s; }
  .sk-carregando-dot:nth-child(4) { animation-delay: -0.8s; }
  .sk-carregando-dot:nth-child(5) { animation-delay: -0.7s; }
  .sk-carregando-dot:nth-child(6) { animation-delay: -0.6s; }
  .sk-carregando-dot:nth-child(1):before { animation-delay: -1.1s; }
  .sk-carregando-dot:nth-child(2):before { animation-delay: -1.0s; }
  .sk-carregando-dot:nth-child(3):before { animation-delay: -0.9s; }
  .sk-carregando-dot:nth-child(4):before { animation-delay: -0.8s; }
  .sk-carregando-dot:nth-child(5):before { animation-delay: -0.7s; }
  .sk-carregando-dot:nth-child(6):before { animation-delay: -0.6s; }
  
  @keyframes sk-carregando {
    100% { } 
  }
  
  @keyframes sk-carregando-dot {
    80%, 100% {  } 
  }
  
  @keyframes sk-carregando-dot-before {
    50% {
      background-color: #f3f3f3;
    }
    75% {
      background-color: #ddd;
    }
    100%, 0% {
      background-color: darkgrey; 
    } 
  }
  
</style>



// WEBPACK FOOTER //
// src/components/CarregandoAguarde.vue